import React, { useState } from "react";

/**
 * Inline "+ NEW TASK" affordance under each day band (date view) or each
 * room group (room view).
 * - Click "+ NEW TASK" button → opens full new-task dialog.
 * - Type title + Enter in the input → quick-add to this day (date view) OR
 *   create a floating task in this room (room view).
 */
export default function NewTaskRow({ dateKey, roomId, colSpan, leftWidth, onOpenDialog, onQuickAdd, mode = "date" }) {
  const [value, setValue] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    const v = value.trim();
    if (!v || busy) return;
    setBusy(true);
    try {
      await onQuickAdd(v);
      setValue("");
    } finally {
      setBusy(false);
    }
  };

  const testKey = mode === "room" ? `room-${roomId || "unassigned"}` : dateKey;
  const placeholder = mode === "room"
    ? "quick-add floating in this room: title + Enter…"
    : "quick-add: type title + Enter…";

  return (
    <div
      style={{ gridColumn: `1 / span ${colSpan}`, height: 28 }}
      className="border-b border-line-subtle flex items-center group"
    >
      <div
        style={{ width: leftWidth, position: "sticky", left: 0 }}
        className="h-full flex items-center bg-bg-base"
      >
        <button
          onClick={() => onOpenDialog && onOpenDialog(dateKey, roomId)}
          className="h-full px-3 mono text-2xs uppercase tracking-[0.2em] text-ink-mute hover:text-amber hover:bg-amber-glow transition-colors flex items-center gap-1"
          data-testid={`new-task-${testKey}`}
          title="Open full new-task dialog (subtasks, custom duration)"
        >
          <span className="text-base leading-none">+</span> NEW TASK
        </button>
        <input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              submit();
            }
            if (e.key === "Escape") setValue("");
          }}
          placeholder={placeholder}
          disabled={busy}
          className="flex-1 h-full bg-transparent text-xs px-2 outline-none placeholder:text-ink-mute placeholder:mono placeholder:uppercase placeholder:tracking-wider focus:bg-bg-elevated"
          data-testid={`new-task-quick-${testKey}`}
        />
      </div>
      <div className="flex-1 h-full" />
    </div>
  );
}
